import { AxiosInstance } from "@bps/http-client";

import { CloudApplicationDto } from "./bp-id.dtos";

export class BpIdGateway {
  constructor(public api: AxiosInstance) {}

  public getCloudApplications = async (): Promise<CloudApplicationDto[]> => {
    return (await this.api.get("ref/cloudApplications")).data;
  };
}
